import { configureStore } from '@reduxjs/toolkit';
import authReducer from './auth';
import globalReducer from './global';
// import teamsReducer from './teams';

export default configureStore({
  reducer: {
    auth: authReducer,
    global: globalReducer,
    // team: teamsReducer,
  },
});
